import React, { useState } from 'react';
import { auth } from '../firebase/config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import toast from 'react-hot-toast';
import AcademyLogo from '../assets/hayaachessacademy-siteicon-favicon.png';

export default function Login() {
    const [loginId, setLoginId] = useState(''); 
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        
        if (!loginId || !password) {
            return toast.error("Please enter both Username and Password.");
        }

        setIsLoading(true);
        const loadingToast = toast.loading("Authenticating...");

        try {
            let finalEmail = loginId.trim().toLowerCase();
            if (!finalEmail.includes('@')) {
                finalEmail = finalEmail.replace(/\s+/g, '') + '@hayaa.com';
            }

            await signInWithEmailAndPassword(auth, finalEmail, password);
            toast.success("Welcome to Hayaa Chess Academy! ♟️", { id: loadingToast });
        } catch (error) {
            console.error("Login Error:", error);
            toast.error("Invalid Username or Password. Access Denied.", { id: loadingToast });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={pageContainerStyle}>
            {/* Pure Neumorphic Login Card */}
            <div className="glass-panel" style={loginCardStyle}>
                <div style={{textAlign: 'center', marginBottom: '35px' }}>
                    <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                        <img 
                            src={AcademyLogo} 
                            alt="Hayaa Chess Academy Logo" 
                            style={{ 
                                width: '80px', 
                                height: '80px', 
                                borderRadius: '16px', 
                                objectFit: 'contain', 
                                background: 'white', 
                                boxShadow: 'var(--neu-shadow)',
                                border: '1px solid rgba(163, 177, 198, 0.3)'
                            }} 
                        />
                    </div>
                    <h2 style={{color: 'var(--text-primary)', margin: '0 0 8px 0', fontSize: '28px', letterSpacing: '0.5px', fontWeight: '800' }}>
                        Hayaa Chess Academy
                    </h2>
                    <p style={{color: 'var(--text-secondary)', margin: 0, fontSize: '14px', fontWeight: '600' }}>
                        Master the board. Elevate your mind.
                    </p>
                </div>

                <form onSubmit={handleEmailLogin} style={{display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <div>
                        <label style={labelStyle}>Academy Username (or Email)</label>
                        <input 
                            type="text" 
                            value={loginId} 
                            onChange={e => setLoginId(e.target.value)} 
                            required 
                            placeholder="e.g. aaravsharma" 
                            className="neu-input"
                            disabled={isLoading}
                        />
                    </div>
                    
                    <div>
                        <label style={labelStyle}>Secure Password</label>
                        <div style={{position: 'relative' }}>
                            <input 
                                type={showPassword ? "text" : "password"} 
                                value={password} 
                                onChange={e => setPassword(e.target.value)} 
                                required 
                                placeholder="••••••••" 
                                className="neu-input"
                                style={{paddingRight: '45px' }} 
                                disabled={isLoading}
                            />
                            <button 
                                type="button" 
                                onClick={() => setShowPassword(!showPassword)}
                                style={{position: 'absolute', right: '15px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '18px', padding: 0, outline: 'none' }}
                                title={showPassword ? "Hide Password" : "Show Password"}
                            >
                                {showPassword ? '🙈' : '👁️'}
                            </button>
                        </div>
                    </div>

                    <button type="submit" className="neu-btn-primary" disabled={isLoading} style={{marginTop: '10px', opacity: isLoading ? 0.7 : 1 }}>
                        {isLoading ? 'Authenticating...' : 'Enter Academy ➔'}
                    </button>
                </form>

                <div style={{textAlign: 'center', marginTop: '35px', fontSize: '13px', color: 'var(--text-secondary)', paddingTop: '20px', borderTop: '1px solid rgba(163, 177, 198, 0.3)' }}>
                    Forgot Password? Please ask your parents to contact the Chief Coach via WhatsApp.
                </div>
            </div>
        </div>
    );
}

const pageContainerStyle = { 
    minHeight: '100vh', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    background: 'var(--bg-primary)', 
    padding: '20px', 
    position: 'relative', 
    overflow: 'hidden' 
};

const loginCardStyle = {
    padding: '40px',
    width: '100%',
    maxWidth: '420px',
    zIndex: 10,
    background: 'var(--bg-primary)',
    boxShadow: 'var(--panel-shadow)',
    borderRadius: '24px',
    border: 'none'
};

const labelStyle = { 
    display: 'block', 
    color: 'var(--text-secondary)', 
    fontSize: '13px', 
    fontWeight: '700', 
    marginBottom: '8px', 
    letterSpacing: '0.5px' 
};
